export const TipologiaUtente = {
    privato: 'Privato',
    agenzia: 'Agenzia',
    costruttore: 'Costruttore',
    amministratore: 'Amministratore',
    collaboratore: 'Collaboratore',
    azienda: 'Azienda',
    mediatore: 'Mediatore'
};



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/tipologia-utente.ts